import { render, staticRenderFns } from "./InspStandardInput.vue?vue&type=template&id=022bb5e8&"
import script from "./InspStandardInput.vue?vue&type=script&lang=js&"
export * from "./InspStandardInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports